import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./SeoBreadcrumbs.css";

function readBreadcrumbsFromHead(pathname) {
  const script = document.head.querySelector('script[data-bp-seo-ld="1"]');
  if (!script) return [];

  try {
    const data = JSON.parse(script.textContent);
    const graph = data["@graph"] || [];
    const page = graph.find((node) => node["@type"] === "WebPage");
    if (!page?.url || new URL(page.url).pathname !== pathname) return [];

    const crumbs = graph.find((node) => node["@type"] === "BreadcrumbList");
    return (crumbs?.itemListElement || []).map((item) => ({
      name: item.name,
      url: item.item,
    }));
  } catch {
    return [];
  }
}

export default function SeoBreadcrumbs({ lang = "de" }) {
  const { pathname } = useLocation();
  const [items, setItems] = useState(() =>
    typeof document === "undefined" ? [] : readBreadcrumbsFromHead(pathname)
  );

  useEffect(() => {
    const onSeoUpdated = (event) => {
      if (event.detail?.path !== pathname) return;
      setItems(event.detail?.breadcrumbs || []);
    };

    window.addEventListener("bestplace:seo-updated", onSeoUpdated);
    setItems(readBreadcrumbsFromHead(pathname));
    return () => window.removeEventListener("bestplace:seo-updated", onSeoUpdated);
  }, [pathname]);

  if (items.length < 2) return null;

  const ariaLabel = {
    de: "Brotkrumennavigation",
    en: "Breadcrumb navigation",
    no: "Brødsmulenavigasjon",
  }[lang] || "Breadcrumb navigation";

  return (
    <nav className="bpBreadcrumbs" aria-label={ariaLabel}>
      <ol className="bpBreadcrumbs__list">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={item.url} className="bpBreadcrumbs__item">
              {index > 0 && (
                <span className="bpBreadcrumbs__separator" aria-hidden="true">›</span>
              )}
              {last ? (
                <span className="bpBreadcrumbs__current" aria-current="page">{item.name}</span>
              ) : (
                <Link to={new URL(item.url).pathname}>{item.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
